export default "__VITE_ASSET__CqLZd8T1__"